// extracted by mini-css-extract-plugin
export default {"container":"jF-z","innerContainer":"kF-z","multipleLines":"lF-z","heading":"mF-z","content":"nF-z","linkColor":"oF-z"};